import * as z from 'zod';

export const updateAccountSchema = z.object({
  name: z.string().min(1, { message: 'Name is required.' }),
  preferred_name: z.string().trim().min(1).max(50).optional(),
  last_name: z.string().min(1, { message: 'Last name is required.' }),
  email: z.string().min(1, { message: 'Email is required.' }).email('Invalid email'),
  password: z.string().optional(),
});

export type UpdateAccountRequest = z.infer<typeof updateAccountSchema>;
